import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58fc6dc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "raraya_name_isSelect" }
const _hoisted_2 = {
  class: "cf",
  style: {"height":"38px"}
}
const _hoisted_3 = { class: "button_no" }
const _hoisted_4 = { class: "button_yes" }
const _hoisted_5 = { class: "summary-col" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "options-list color-options"
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 3,
  class: "name-char"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-col" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "button edit-button" }, "編集する")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormOption = _resolveComponent("FormOption")!
  const _component_FormTab = _resolveComponent("FormTab")!

  return (_openBlock(), _createBlock(_component_FormTab, {
    class: "name-content",
    index: _ctx.index
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onNoClick && _ctx.onNoClick(...args))),
              class: _normalizeClass({ selected: _ctx.configNonameId == _ctx.nameSettings.noName.id }),
              id: "raraya_name_no"
            }, "× 入れない", 2)
          ]),
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onYesClick && _ctx.onYesClick(...args))),
              id: "raraya_name_yes"
            }, "○ 入れる")
          ])
        ])
      ], 512), [
        [_vShow, _ctx.configNonameId != _ctx.nameSettings.yesName.id]
      ]),
      _withDirectives(_createElementVNode("div", {
        class: "name-summary",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openMobileNameDialog && _ctx.openMobileNameDialog(...args)))
      }, [
        _createElementVNode("div", _hoisted_5, [
          (!_ctx.configNamethreadId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, "色が未選択です"))
            : _createCommentVNode("", true),
          (_ctx.configNamethreadId)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                _createVNode(_component_FormOption, {
                  optionType: 'color',
                  option: _ctx.options.find((x) => x.id == _ctx.configNamethreadId),
                  isSelected: true
                }, null, 8, ["option"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.configNamechar)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, "文字が未入力です"))
            : _createCommentVNode("", true),
          (_ctx.configNamechar)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.convertName(_ctx.configNamechar)), 1))
            : _createCommentVNode("", true)
        ]),
        _hoisted_10
      ], 512), [
        [_vShow, _ctx.configNonameId == _ctx.nameSettings.yesName.id]
      ])
    ]),
    _: 1
  }, 8, ["index"]))
}